import { List, Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { Loading } from "shared-ui/global/Loading";
import { CardMode } from "./DisplayCard";
import { DisplayListHeader, DisplayListHeaderProps } from "./DisplayListHeader";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loading: {
      height: "unset",
      marginTop: theme.spacing(1),
    },
  })
);

export interface IDAbleStringOrNumber {
  id: string | number;
}

export interface RenderListItemArgs<T extends IDAbleStringOrNumber> {
  element: T;
  disabled: boolean;
  focused: boolean;
  mode: CardMode;
  key: string;
}

interface DisplayListProps<EdgeType extends IDAbleStringOrNumber> {
  title: string;
  renderListItem: (args: RenderListItemArgs<EdgeType>) => JSX.Element;
  columnMode: CardMode;
  selectedId: string | null;
  disabled?: boolean;
  elements: readonly EdgeType[];
  loading: boolean;
  headerVariant?: DisplayListHeaderProps["variant"];
}

export const DisplayList = <EdgeType extends IDAbleStringOrNumber>({
  title,
  renderListItem,
  columnMode,
  selectedId,
  disabled: _disabled = false,
  elements,
  loading,
  headerVariant,
}: DisplayListProps<EdgeType>) => {
  const classes = useStyles();
  const renderItem = (element: EdgeType) => {
    const focused = element.id === selectedId;
    const disabled = !focused && _disabled;

    return renderListItem({
      element,
      disabled,
      focused,
      mode: columnMode,
      key: `listItem-${element.id}`,
    });
  };

  return (
    <List disablePadding>
      <DisplayListHeader title={title} variant={headerVariant} />
      {loading ? <Loading progressSize="xs" classes={{ root: classes.loading }} /> : elements.map(renderItem)}
    </List>
  );
};
